import Vue from "vue";
import Vuelidate from "vuelidate";

import DynamicForm from "@/components/DynamicForm/DynamicForm.vue";
import StorePromo from "@/components/StorePromo.vue";
import BootstrapVue from "bootstrap-vue";
import store from "./store/store";
import VueGtm from "@gtm-support/vue2-gtm";

import "./style/style.scss";
import "./style/quote/index.scss";
import "./style/appointment/index.scss";
import "./style/appointment/appt_store.scss";
import "./style/appointment/appt_service.scss";
import "./style/appointment/appt_date.scss";
import "./style/appointment/appt_contact.scss";
import "./style/appointment/appt_confirm.scss";

import * as VueGoogleMaps from "vue2-google-maps";

// Create 'page' that utilizes the standard quote flow and see if we can swap in the store selector with new one, and if not, then just use the standard quote flow and call it a day.
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueGtm, {
  id: "GTM-PLHN39K",
  queryParams: {},
  debug: false,
  loadScript: true,
});

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyB1aX0Ss-xisZEtUnBwyvfiU_zgzQyIP30",
    libraries: "places",
    // v: '3.40',
  },
}),
  new Vue({
    render: (h) =>
      h(DynamicForm, {
        props: {
          useServices: false,
          confirmTitle: "Dynamic Title",
          componentNames: [
            { name: "AffiliateStoreSelect" },
            { name: "ApptService" },
            { name: "appt-contact" },
            { name: "DynamicConfirm" },
          ],
          confirmComponents: [
            "StoreConfirm",
            "ServiceConfirm",
            "ContactConfirm",
          ],
          canSubmitLead: (store) => {
            return store.getters.serviceLeadValid;
          },
          onConfirm: (store, gtm) => {
            store.dispatch("submitAffiliateLead").then(function () {
              gtm.trackEvent({
                event: "generate_lead",
                category: "Lead",
                action: " lead captured",
                label: "",
                noninteraction: false,
              });
            });
          },
          reviewNames: [
            "FormStoreReview",
            "FormServiceReview",
            "FormContactReview",
          ],
          formTitle: "Title",
          formSteps: [
            { label: "Store" },
            { label: "Services" },
            { label: "Contact Info" },
            { label: "Confirm" },
          ],
        },
      }),
    store,
  }).$mount("#affiliate-insert");
new Vue({
  render: (h) => h(StorePromo, { props: { formType: "ppc" } }),
  store,
}).$mount("#promotion-insert");
